export const appBasePath = "/";
export const APIBasePath="https://marketsentiment.live/market-sentiment/";
